import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Menu, Space, Typography, Popover } from "antd";
import {
  MoreOutlined,
  LogoutOutlined,
  ShrinkOutlined,
  ArrowsAltOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { isMobile } from "react-device-detect";
import { isEmptyObject } from "jquery";

import { cleanUpReport } from "../../../actions/reportDetailsAction";
import { cleanResourcesList } from "../../../actions/resourcesAction";
import { RootState } from "../../../store/store";
import { useKeycloakUserInfo } from "../../../hooks/useKeycloakUserInfo";
import {
  menuShowDrawner,
  closeDrawner,
  menuItemSelected,
  menuFullScreen,
} from "../../../actions/menuAction";
import MobileMenu from "./MobileMenu";
import ShareLink from "./ShareLink";
import "antd/dist/antd.css";
import BreadcrumbComponent from "./Breadcrumb";
import { resourceTypeEnum } from "../../../types/resourceType";
import { useState, useEffect } from "react";
import DrawerMenu from "./DrawerMenu";
import axiosInstance from "../../../utils/axiosInstance";
import ExportItem from "./ExportItem";

const { Text } = Typography;

// const markFilesAsNotified = async () => {
//   try {
//     await axiosInstance.post("/");
//   } catch (err) {
//     console.error(err);
//   }
// };

const MenuComponent = () => {
  let history = useHistory();
  let export_screen_enabled: boolean = true;

  const { initialized, keycloak, userInfo } = useKeycloakUserInfo();
  const userState = useSelector((state: RootState) => state.user);
  const reportState = useSelector((state: RootState) => state.report);
  const resourcestState = useSelector((state: RootState) => state.resources);
  const menuState = useSelector((state: RootState) => state.menu);
  const docElement = document.documentElement;
  const dispatch = useDispatch();

  const logoutHandler = () => {
    history.push("/");
    dispatch(cleanUpReport());
    dispatch(cleanResourcesList());
    keycloak.logout();
  };
  const menuDrawer = () => {
    menuState.menu.showDrawer
      ? dispatch(closeDrawner())
      : dispatch(menuShowDrawner());
  };

  const handleSelectedKey = (e: any) => {
    e.key === menuState.menuItemSelected
      ? dispatch(menuItemSelected("0"))
      : dispatch(menuItemSelected(e.key));
  };

  const exitFullscreen = () => {
    if (document.fullscreenElement) document.exitFullscreen();
  };

  const handleFullScreenClick = () => {
    dispatch(menuFullScreen(!menuState.menu.fullScreen));
    menuState.menu.fullScreen
      ? exitFullscreen()
      : docElement.requestFullscreen();
  };

  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {}, []);

  return !isMobile ? (
    <>
      <Menu
        theme={
          resourcestState.resourceSelected?.type === resourceTypeEnum.REPORT
            ? reportState.report.config?.showHeader
              ? "light"
              : "dark"
            : "dark" //datasets case
        }
        mode="horizontal"
        onClick={handleSelectedKey}
        selectedKeys={menuState.menuItemSelected}
        style={{ justifyContent: "flex-start" }}
      >
        <Menu.Item
          key="1"
          icon={<MoreOutlined style={{ fontSize: "120%" }} />}
          onClick={menuDrawer}
          disabled={
            isEmptyObject(resourcestState.resources.data) ? true : false
          }
        />
        <Menu.Item
          key="2"
          style={{ pointerEvents: "none", borderColor: "none" }}
        >
          <Space style={{ marginTop: "2px" }}>
            {resourcestState.resourceSelected.name ? (
              <BreadcrumbComponent />
            ) : (
              <div></div>
            )}
          </Space>
        </Menu.Item>
        <Menu.Item
          key="3"
          style={{
            marginLeft: "auto",
            pointerEvents: "none",
            marginTop: "2px",
          }}
        >
          <Text>
            <FormattedMessage
              id="header.span.welcome"
              defaultMessage="Bienvenido"
            />
            {initialized ? ` ${userState.firstName} ${userState.lastName}` : ""}
          </Text>
        </Menu.Item>
        <Menu.Item
          key="4"
          icon={
            menuState.menu.fullScreen ? (
              <ShrinkOutlined
                style={{ fontSize: "120%" }}
                onClick={handleFullScreenClick}
              />
            ) : (
              <ArrowsAltOutlined
                style={{ fontSize: "120%" }}
                onClick={handleFullScreenClick}
              />
            )
          }
        />
        <Popover
          style={{ top: 20 }}
          placement="bottomRight"
          content={<ShareLink />}
          trigger="click"
          arrowPointAtCenter
        >
          <Menu.Item
            key="5"
            icon={<ShareAltOutlined style={{ fontSize: "120%" }} />}
            disabled={
              isEmptyObject(resourcestState.resources.data) ? true : false
            }
          />
        </Popover>

        {userInfo.export_screen_enabled && (
          <>
            <ExportItem
              handleClick={async () => {
                setDrawerOpen(!drawerOpen);
              }}
              theme={
                resourcestState.resourceSelected?.type ===
                resourceTypeEnum.REPORT
                  ? reportState.report.config?.showHeader
                    ? "light"
                    : "dark"
                  : "dark"
              }
            />
            <DrawerMenu
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            />
          </>
        )}

        <Menu.Item
          key="7"
          icon={<LogoutOutlined style={{ fontSize: "120%" }} />}
          onClick={logoutHandler}
        />
      </Menu>
    </>
  ) : (
    <MobileMenu />
  );
};
export default MenuComponent;
